
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Senior Consultant (Multimedia)
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">



         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Educational Qualification: </h3>
              <p> Graduate in B.E., Computer 
                Science/MBA/M.Sc, Electronic Media/M.Sc., 
                (Visual Communication) or any relevant Master 
                Degree from recognized University or institute .</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Eligibility Criteria: </h3>
              <p> Graduate - min 5 years of 
                experience in relevant field <br>
                 Post graduate min 3-5 years 
                experience  in relevant field<br>
                Should have 2 years' managerial level 
experience in e-learning or animation firms or 
media houses
                 
</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Job requirement: </h3>
              <p><p><span class="step_no">1</span> Project planning managing, Team
                Management, vendors, SMEs and technical 
                expert's Coordination Problem Solving 
                Creating weekly and monthly reports</p>
                <p><span class="step_no">2</span>Lead project's as per the requirement & 
ensure the goals for the e-learning strategy, 
through evaluation at different levels</p>
<p><span class="step_no">3</span>Monitor project progress and make necessary adjustments to ensure successful execution. </p>
<p><span class="step_no">4</span>Foster effective communication among project team members and stakeholders</p>
<p><span class="step_no">5</span>Establish quality standarde and ensure project deliverables</p>
<p><span class="step_no">6</span>Conduct regular inspections and assessments to monitor the quality of projects </p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p>Rs. 60,000/- to Rs. 70,000/- per month. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 23th June 2024 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->
<!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Key Responsibility:</h3>
		
        <p> <span class="step_no">1</span> 
            Preparing, updating and maintaining records / data pertaining to all Multimedia activities </p>
        <p> <span class="step_no">2</span> Managing and handling different types of Multimedia content developed by NIMI </p>
        <p> <span class="step_no">3</span>Assigning and coordinating work with Junior consultants,</p>
        <p><span class="step_no">4</span>Coordinating with empaneled Agencies/ firms to complete different Multimedia works </p>
        <p><span class="step_no">5</span>To work independently in self-guided mode and  solve problems</p>
        
      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Skills and Competencies:</h3>
		
                  <p> <span class="step_no">1</span>Excellent writing and communication skills</p>
        <p> <span class="step_no">2</span>Strong analytical and documentation skills</p>
        <p> <span class="step_no">3</span>Experience of using automated accounting applications and MS Office</p>
			

        <p> <span class="step_no">4</span>Strong presentation skills and interpersonal skills</p>

		 <p> <span class="step_no">5</span>Should be able to operate in unstructured environment with minimal support.</p>
 <p> <span class="step_no">6</span>Openness to travel if required</p>





      </div>
    </div>
  </div> -->
  <!-- feature box close -->

    <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Key responsibilities:</h3>
        
			
<p><span class="step_no">1</span>Design, implement and Support financial management systems and procedures
</p>
<p><span class="step_no">2</span>Ensure fulfil1ment of requirements as laid under the financial management manual of SANKALP</p>
<p><span class="step_no">3</span>Prepare necessary financial reports including budget preparation, maintaining books of accounts, statement of expenditure etc.</p>
<p><span class="step_no">4</span>Support MSDE and other	stakeholders for fulfilling	audit requirements of SANKALP</p>
<p><span class="step_no">5</span>Support in bringing collaboration and partnership with various stakeholders.</p>
<p><span class="step_no">6</span>Develop periodic reports as per MSDE requirements</p>
<p><span class="step_no">7</span>Any other work as per MSDE requirement.</p>

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->

          <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Period of Contract:</h3>
            <p>11 Months (extendable based on performance)</p>

           

    
          </div>
        </div>
      </div>
      <!-- feature box close -->

 <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Method of recruitment:</h3>
            <p>Contract based through open market</p>

           

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->
    
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
       		<p>Chennai </p>





      </div>
    </div>
  </div>
  <!-- feature box close -->

 <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Division</h3>
       		<p>Multimedia</p>





      </div>
    </div>
  </div>
  <!-- feature box close -->


  

<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>


